import { NgModule } from '@angular/core';
import { CommonModule, DatePipe, TitleCasePipe } from '@angular/common';
import { CustomerHomeRoutingModule } from './customer-home-routing.module';
import { MaterialModule } from 'src/app/material/material.module';
import { CusSolutionsComponent } from './components/cus-solutions/cus-solutions.component';
import { ProductDetailsComponent } from './components/product-details/product-details.component';
import { AvlSolutionsComponent } from './components/avl-solutions/avl-solutions.component';
import { HomeComponent } from './components/home/home.component';
import { DataManagementModule } from '../data-management/data-management.module';
import { AvlSolutionHomeComponent } from './components/avl-solution-home/avl-solution-home.component';
import { TextPrettyPipe } from 'src/app/pipes/text-pretty.pipe';
import { AddUserInSubscribedSolnComponent } from './components/add-user-in-subscribed-soln/add-user-in-subscribed-soln.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NamingSizePipe } from 'src/app/pipes/naming-size.pipe';

@NgModule({
  declarations: [
    CusSolutionsComponent,
    AvlSolutionsComponent,
    HomeComponent,
    AvlSolutionHomeComponent,
    AddUserInSubscribedSolnComponent,
  ],
  imports: [
    CommonModule,
    CustomerHomeRoutingModule,
    MaterialModule,
    DataManagementModule,
    ProductDetailsComponent,
    TextPrettyPipe,
    TitleCasePipe,
    DatePipe,
    ReactiveFormsModule,
    FormsModule,
    NamingSizePipe
  ],
})
export class CustomerHomeModule {}
